// 速腾聚创
import Overview from '@rebuild/materials/shared/announcement/OverviewIndex.vue';
import Full from '@rebuild/materials/shared/announcement/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';
import i18n from '@/locales';

function useSelfContext() {
	provideCurrentContext({
		tabContent: [
			{
				label: ['zh-cn', 'zh-hk'].includes(i18n.locale) ? '公告及通函' : 'Announcements and Notices',
				value: ''
			}
		]
	});
}

export const componentMap = {
	overview: Overview,
	full: withProvider(Full, useSelfContext),
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
